// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__qZa61","inputWrap":"CustomTip_inputWrap__1kT54"};